var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11624 17.2199C17.2779 11.5752 26.0545 7.85352 30.4458 6.0556C42.984 0.92187 45.5891 0.0301518 47.2874 0.000287021C47.6606 -0.0058971 48.4957 0.0853566 49.0369 0.51734C49.4935 0.882053 49.6191 1.37497 49.6795 1.72098C49.7396 2.06669 49.8143 2.85494 49.7549 3.47064C49.0755 10.4982 46.1355 27.5525 44.6397 35.4235C44.0069 38.7542 42.7606 39.871 41.5541 39.9802C38.9325 40.2176 36.9415 38.2746 34.402 36.6359C30.4284 34.0718 28.1837 32.4754 24.3265 29.9734C19.8689 27.0816 22.7587 25.4924 25.2991 22.8951C25.9638 22.2155 37.5158 11.872 37.7392 10.9335C37.7674 10.8162 37.7932 10.3788 37.5293 10.1477C37.2651 9.91691 36.8757 9.99594 36.5943 10.0587C36.196 10.1477 29.848 14.2781 17.5507 22.4496C15.7488 23.6677 14.1167 24.2611 12.6546 24.23C11.0424 24.1956 7.94158 23.3325 5.63638 22.595C2.80897 21.6903 0.56179 21.2118 0.757486 19.6755C0.859409 18.8751 1.97897 18.0564 4.11624 17.2199Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.cddeab6ace8be56c78e46cddb3cdbbbe.svg";
export { ForwardRef as ReactComponent };